module.exports = __webpack_public_path__ + "aa25c0962e050c68a8b4e8baf9249591.svg";